export default "__VITE_ASSET__f8f2303b__"